
function InitializeSearch() {
  $('.searchBox #btnSearch').on('click', function () {
    let expandedState = $(this).attr('aria-expanded');

    if (ariaPressedState === undefined) {
      $(btnClicked).attr('aria-pressed', true);
    } else {
      $(btnClicked).attr('aria-pressed', ariaPressedState === 'true' ? 'false' : 'true');
    }
  });

  window.onload = function () {
    let placeholderText = '';
    var theLanguage = $('html').attr('lang');

    if (theLanguage === 'en') {
      placeholderText = 'Search Site:' 
    }
    else {
    placeholderText = 'Buscador'
    }

    let googleSearchBox = $('#gsc-i-id1')

    if (googleSearchBox.length > 0) {
      document.getElementById('gsc-i-id1').placeholder = placeholderText;
    }

    $('#gsc-i-id1').on('focus', function () {
      $(this).attr('placeholder', '');
    });

    $('#gsc-i-id1').on('focusout', function () {
      $(this).attr('placeholder', placeholderText);
    });
  };


}

document.addEventListener('DOMContentLoaded', (event) => {
  InitializeSearch()
})
